<template>
    <div>
        <h2>Beschreibung eingeben</h2>
        <div class="form-group">
            <label for="title">
                Titel*
                <font-awesome-icon
                    v-b-popover.hover.right="$t('intern_inserieren.infoAll')"
                    icon="question-circle"
                    class="mm-link"
                    style="font-size: 11pt;"
                />
            </label>
            <input type="text" class="form-control" v-model.trim="name" maxlength="100" id="title" placeholder="Titel eingeben" @input="$v.name.$touch()" :class="{ 'is-invalid': $v.name.$error }">
            <div class="invalid-feedback" v-if="!$v.name.maxLength">Maximale Zeichengrenze erreicht</div>
        </div>
        <div class="form-group">
            <label for="description">
                Beschreibung*
                <font-awesome-icon
                    v-b-popover.hover.right="$t('intern_inserieren.infoDescription')"
                    icon="question-circle"
                    class="mm-link"
                    style="font-size: 11pt;"
                />
            </label>
            <ckeditor style="height: 500px;" type="classic" v-model="description" :config="{toolbar: [ 'heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'undo', 'redo' ]}"></ckeditor>
        </div>
        <div class="form-group">
            <label for="rental_conditions">
                Mietbedingungen
                <span v-if="isMobile" class="text-muted font-10 mm-link" @click="chooseObject">Daten übernehmen</span>
                <span v-else class="text-muted font-10 mm-link" @click="chooseObject">Ihre bereits verwendeten Mietbedingungen benutzen</span>
            </label>
            <ckeditor style="height: 500px;" type="classic" v-model="rental_conditions" :config="{toolbar: [ 'heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'undo', 'redo' ]}"></ckeditor>
        </div>
        <div>
          <span>Alle mit * markierten Felder sind Pflichtfelder</span>
        </div>
        <div v-if="isMobile" class="mt-3 text-center">
            <button v-if="create" class="btn btn-success w-100" @click="weiter()">Weiter</button>
            <button v-if="!create" class="btn btn-success mb-1 w-100" @click="save(true)">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success w-100" @click="save()">Weiter</button>
        </div>
        <div v-else class="mt-3 text-right">
            <button v-if="create" class="btn btn-success" @click="weiter()">Weiter</button>
            <button v-if="!create" class="btn btn-success mx-2" @click="save(true)">Speichern und Schließen</button>
            <button v-if="!create" class="btn btn-success" @click="save()">Weiter</button>
        </div>
        <b-modal ref="error-modal" :title="'Fehlermeldung'">
            <div class="d-block">
                <p>{{$t('intern_object_erstellen.description_error')}}</p>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="danger" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
        <b-modal ref="choose-object-modal" size="lg" :title="'Wählen Sie das Inserat, wovon Sie die Mietbedingungen übernehmen möchten.'">
            <div class="d-block">
                <div class="accordion" id="accordion" v-if="tinyObjects.length > 0">
                    <div class="card" v-for="object in tinyObjects" :key="object.id">
                        <div class="card-header pointer" data-toggle="collapse" :data-target="'#collapse' + object.id" @click="toggleCollapse(object.id)">
                            <h5>
                                Inserats-Nummer {{object.id}} - {{object.name}}
                                <font-awesome-icon class="float-right" icon="chevron-down" v-if="active_rental_condition != object.id"/>
                                <font-awesome-icon class="float-right" icon="chevron-up"   v-if="active_rental_condition == object.id"/>
                            </h5>
                        </div>
                        <div :id="'collapse' + object.id" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                            <div class="card-body">
                                <div v-html="object.content"></div>
                                <div class="text-right">
                                    <button class="btn btn-success" @click="importRentalConditions(object.content)">Übernehmen</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-warning" v-else>Sie haben bisher keine Mietbedingungen angegeben, die Sie übernehmen können.</div>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="secondary" @click="cancel()">Schließen</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Inserat from '../../../classes/Inserat';
    import {required, maxLength, minLength} from "vuelidate/lib/validators";
    import { IsMobileMixin } from '../../../mixins/IsMobile';

    export default {
        data() {
            return {
                name: '',
                description: '',
                rental_conditions: '',
                inserat: Inserat,
                tinyObjects: [],
                active_rental_condition: 0
            }
        },
        mixins: [IsMobileMixin],
        props:['create'],
        created() {
            this.scrollTop();
            if(this.create){
                let jsonObject = JSON.parse(localStorage.getItem('currentObject'));
                this.inserat = Inserat.getObjectFromJSON(jsonObject);

                if(this.inserat.getName()){
                    this.name = this.inserat.getName();
                }

                if(this.inserat.getDescription()){
                    this.description = this.inserat.getDescription();
                }

                if(this.inserat.getRentalConditions()){
                    this.rental_conditions = this.inserat.getRentalConditions();
                }
            }else {
                let object = this.$store.state.editObject;
                this.description = object.description;
                this.name = object.name;
                this.rental_conditions = object.rental_conditions;
            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            importRentalConditions(content) {
                this.rental_conditions = content;
                this.$refs['choose-object-modal'].hide();
            },
            toggleCollapse(id) {
                if(this.active_rental_condition == id){
                    this.active_rental_condition = 0;
                }else{
                    this.active_rental_condition = id;
                }
            },
            chooseObject() {
                this.$http.get('objectApi/getAllRentalConditions').then(response => {
                    this.tinyObjects = JSON.parse(response.data);
                    this.$refs['choose-object-modal'].show();
                }).catch(error => {console.log(error);});
            },
            saveCookie(id = 0, gotoNextTab = true) {
                if(id > 0){
                    this.inserat.setId(id);
                }
                this.inserat.setName(this.name);
                this.inserat.setDescription(this.description);
                this.inserat.setRentalConditions(this.rental_conditions);
                localStorage.setItem('currentObject', JSON.stringify(this.inserat));
                if(gotoNextTab){
                    localStorage.setItem('currentObjectTab', 'foto');
                    this.$emit('nextTab','foto');
                }
                this.$store.state.loading = false;
            },
            weiter(gotoNextTab = true) {
                if(this.name != '' && this.description != ''){
                    this.$store.state.loading = true;

                    let jsonObject            = JSON.parse(localStorage.getItem('currentObject'));
                    let inserat               = Inserat.getObjectFromJSON(jsonObject);
                    inserat.name              = this.name;
                    inserat.description       = this.description;
                    inserat.rental_conditions = this.rental_conditions;

                    if(gotoNextTab)
                      this.saveCookie();
                    else
                      this.saveCookie(0,gotoNextTab);
                }else{
                    this.$refs['error-modal'].show()
                }
            },
            save(closeAfter = false) {
                if(this.name != '' && this.description != ''){
                    let object = this.$store.state.editObject;
                    object.name = this.name;
                    object.description = this.description;
                    object.rental_conditions = this.rental_conditions;

                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id, object).then(response => {
                        this.$store.state.editObject = object;
                        this.$store.state.loading = false;
                        this.$emit('success', response.data);
                        if(closeAfter){
                            setTimeout(() => {
                                this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                            }, 1000);
                        }
                        else{
                          this.$emit('nextTab','foto');
                        }

                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }else{
                    this.$refs['error-modal'].show()
                }
            }
        },
        validations: {
            name: {
                required,
                maxLength: maxLength(99)
            }
        },
        beforeDestroy() {
          if(this.create){
            this.weiter(false);
          }
        }
    }
</script>

<style>
.ck-content{
    min-height: 300px;
    max-height: 300px;
}
li.list-group-item:hover{
    background-color: #eee;
    cursor: pointer;
}
</style>
